import { connect } from 'react-redux';
import WebexChannels from '../components/webex_channels/webex_channels';
import { updateWebexBlacklist, addToWebexBlacklist, removeFromWebexBlacklist } from '../actions/webex';

function mapStateToProps({ webex }) {
  const { teams } = webex;
  return {
    teams,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateBlacklist: ({ removeIds, addIds }) => (
      dispatch(updateWebexBlacklist({ removeIds, addIds }))
    ),
    addToBlacklist: (channelId, teamId) => (
      dispatch(addToWebexBlacklist(channelId, teamId))
    ),
    removeFromBlacklist: (channelId, teamId) => (
      dispatch(removeFromWebexBlacklist(channelId, teamId))
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WebexChannels);



// WEBPACK FOOTER //
// ./src/containers/webex_channels.js